// Copyright 2021 Prescryptive Health, Inc.

export const drawerWidth = 292;
export const topBarHeight = 90;
